import { ReactElement, SyntheticEvent, useEffect, useState } from 'react'
import {
  PageWrapper,
  FlexWrapper,
  SectionTitle,
  DropdownWrapper,
  EditableDropdown,
  Input,
  FileUploader,
  ActionButton,
  Button,
  Loader
} from '../../../components'
import { validateRequired } from '../../../helpers/formValidation'
import strings from '../../../locale/en'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'
import { getBatchDropdown } from '../../../helpers'
import { getBatches } from '../../../redux/coachingCenter/actions'
import DatePicker from 'react-datepicker'
import { useHistory } from 'react-router-dom'
import { addAssignment } from '../../../redux/test/api'

const Assignment = (): ReactElement => {
  const { batches, userInfo, isLoading } = useSelector(
    (state: RootState) => ({
      batches: state.coachingCenter.batches,
      userInfo: state.user.userInfo,
      isLoading: state.test.isLoading
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()
  const initialValues = {
    title: '',
    description: '',
    date: new Date(),
    attachment: null,
    batchId: ''
  }
  const [formValues, setFormValues] = useState(initialValues)
  const [assignmentTitleError, setAssignmentTitleError] = useState('')
  const batchList = batches ? getBatchDropdown(batches) : []
  const [assignmentDescriptionError, setAssignmentDescriptionError] =
    useState('')
  const { title, batchId, description, date, attachment } = formValues
  const canSaveAttachment =
    title && batchId && description && date && attachment
  const {
    menu: {
      admin: { assignment, assignmentStartDate, selectBatch }
    },
    button: { save, back }
  } = strings

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()
    dispatch(
      addAssignment({
        batchId: formValues.batchId,
        files: formValues.attachment,
        title: formValues.title,
        description: formValues.description,
        date: formValues.date?.toDateString()
      })
    )
    setFormValues({
      ...initialValues,
      batchId: formValues?.batchId
    })
  }

  useEffect(() => {
    const branchId = userInfo?.userDetail?.branchIds?.length
      ? userInfo?.userDetail?.branchIds[0]
      : ''

    dispatch(
      getBatches({
        coachingCentreId: userInfo?.userDetail?.coachingCenterId || '',
        branchId: branchId,
        type: 'COACH'
      })
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <FlexWrapper justifyContent="space-between" hasBorder>
        <SectionTitle title={assignment} />
      </FlexWrapper>
      <FlexWrapper noPadding>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={batchList || []}
            title={selectBatch}
            placeholder={selectBatch}
            isRequired
            handleSelect={(batch) => {
              setFormValues({
                ...formValues,
                batchId: batch?.id
              })
            }}
          />
        </DropdownWrapper>
        <Input
          label={'Title'}
          isRequired
          placeholder={'Enter Title'}
          name="title"
          width="30%"
          value={formValues?.title}
          onBlur={() => {
            const error = validateRequired(formValues.title)
            setAssignmentTitleError(error)
          }}
          error={assignmentTitleError}
          onChange={(value: string) => {
            setFormValues({
              ...formValues,
              title: value
            })
          }}
        />
        <DropdownWrapper>
          <DatePicker
            selected={formValues?.date}
            onSelect={(date: Date) => {
              setFormValues({
                ...formValues,
                date: date
              })
            }}
            onChange={(date: Date) => {
              setFormValues({
                ...formValues,
                date: date
              })
            }}
            placeholderText={assignmentStartDate}
            customInput={
              <Input
                value={formValues?.date?.toDateString()}
                inputType="text"
                label={assignmentStartDate}
                placeholder={assignmentStartDate}
                suffix={['far', 'calendar']}
              />
            }
          />
        </DropdownWrapper>
      </FlexWrapper>
      <FlexWrapper noPadding>
        <DropdownWrapper width="80%">
          <Input
            label={'Description'}
            value={formValues?.description}
            name={'description'}
            onBlur={() => {
              const error = validateRequired(formValues?.description)
              setAssignmentDescriptionError(error)
            }}
            error={assignmentDescriptionError}
            onChange={(value) => {
              setFormValues({
                ...formValues,
                description: value
              })
            }}
            isRequired
            hasPadding={false}
            inputType="textarea"
          />
        </DropdownWrapper>
      </FlexWrapper>
      <FileUploader
        onUploadSuccess={(file) => {
          setFormValues({
            ...formValues,
            attachment: file
          })
        }}
      />
      <FlexWrapper justifyContent="center">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <ActionButton
              variant="outline-secondary"
              onClick={() => {
                history.goBack()
              }}
            >
              {back}
            </ActionButton>
            <Button onClick={handleSubmit} disabled={!canSaveAttachment}>
              {save}
            </Button>
          </>
        )}
      </FlexWrapper>
    </PageWrapper>
  )
}

export default Assignment
